import { List } from 'services/api/list/types';

import { DimensionRow } from '../types';

export const dimensionsRowToList = (dimensionRow: DimensionRow): List => ({
  ...dimensionRow,
  words: dimensionRow.words ?? []
});
